export function initQuickExitButton(context, once) {
  once("quickExitButton", "#quick-exit-button", context).forEach(
    (quickExitBtn) => {
      console.log("quickExitBtn", quickExitBtn);
      quickExitBtn.addEventListener("click", function (e) {
        e.preventDefault();
        window.open("https://www.google.com", "_blank");
        window.location.href = "https://www.google.com";
      });
    }
  );
}
